import React from "react";
import { Pagination as AntdPagination } from "antd";
import classNames from "classnames";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

// interfaces
import { IPagination } from "./IPagination";

// assets
import styles from "@/assets/styles/components/pagination.module.scss";


const renderItems = (_: number, type: "prev" | "next" | "page" | "jump-prev" | "jump-next", originalElement: unknown) => {

  if (type === "prev") {
    return (
      <span className="ant-pagination-item-link locl-pagination__arrow" data-testid="locl-pagination-prev">
        <FaChevronLeft/>
      </span>
    );
  }

  if (type === "next") {
    return (
      <span className="ant-pagination-item-link locl-pagination__arrow" data-testid="locl-pagination-next">
        <FaChevronRight/>
      </span>
    );
  }

  const antdOriginalElement = originalElement as React.ReactElement;

  return {
    ...antdOriginalElement,
    props: { ...antdOriginalElement.props, className: "locl-pagination__page-item", "data-testid": "", "data-paginated-page": antdOriginalElement.props.children }
  };
};

function Pagination({ className, itemRender, ...props }: IPagination) {
  const paginationClassNames = classNames(
    styles["locl-pagination"],
    "locl-pagination",
    className
  );

  return (
    <AntdPagination
      showSizeChanger={false}
      { ...props }
      className={paginationClassNames}
      itemRender={itemRender || renderItems}
      showTitle={false}
    />
  );
}

export default Pagination;
